// extend libraries
import {
  translateSingleString as remoteTranslateSingleString,
  Trns,
} from '@paywithextend/localization'
import { connect } from 'react-redux'
import { defaultLocale } from 'src/configurations'
import { SupportedBrands } from 'src/enums'
import { getLocaleInfo } from 'src/localization/locales'
import { useTranslate } from 'src/localization/useTranslate'
import { RootState } from 'src/redux/createRootReducer'
import { selectNullSafeLocaleFromState } from 'src/redux/selectors/auth.selectors'

/**
 * @deprecated This component is deprecated and should not be used in new code.
 * Use the useTranslate hook instead.
 */
export const translateSingleString = (
  locale: string,
  source: string,
  expressions?: Record<string, string> | undefined,
): string => {
  return remoteTranslateSingleString(
    getLocaleInfo(locale).jsonTranslations,
    getLocaleInfo(defaultLocale).jsonTranslations,
  )(source, expressions)
}

export { useTranslate }

/**
 * @deprecated This component is deprecated and should not be used in new code.
 * Use the useTranslate hook instead.
 */
export default connect((state: RootState) => {
  const whitelabelBrand = state.session.brandConfig
    .BRAND_NAME as SupportedBrands
  const locale = selectNullSafeLocaleFromState(state)
  return {
    localeTranslation: getLocaleInfo(locale, whitelabelBrand).jsonTranslations,
    defaultTranslation: getLocaleInfo(defaultLocale, whitelabelBrand)
      .jsonTranslations,
  }
}, {})(Trns)
